<template>

    <div>
        <section class="dashboard-area">
            <div class="dashboard_menu_area" v-if="data.owner && currentUserData && data.owner.id === currentUserData.id">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <ul class="dashboard_menu">
                                <li :class="{active: currentComponent === 'profile'}">
                                    <a class="cursor-pointer" @click="changeComponent('profile')">
                                        <span class="icon icon-profile"></span>
                                        {{$store.getters.t('main_menu_profile')}}
                                    </a>
                                </li>
                            </ul>
                            <!-- end /.dashboard_menu -->
                        </div>
                        <!-- end /.col-md-12 -->
                    </div>
                    <!-- end /.row -->
                </div>
                <!-- end /.container -->
            </div>
            <!-- end /.dashboard_menu_area -->
            <transition name="component-fade" mode="out-in">
                <component :is="currentComponent" :organization="data"></component>
            </transition>

        </section>
    </div>


</template>

<script>

import Profile from './OrganizationProfile'

export default {
    props: ['data'],
    name: "OrganizationBackendComponent",
    components: {
      Profile
    },

    data(){
        return{
            currentComponent: '',
        }
    },

    created() {
        window.addEventListener("hashchange",this.windowHashTabs, false);
    },
    destroyed(){
        window.removeEventListener("hashchange",this.windowHashTabs);
    },
    mounted() {
        this.currentComponent = window.location.hash ? window.location.hash : 'profile';
    },
    computed: {
        currentUserData() {
            return this.$store.getters.getUserData;
        },
    },
    methods: {
        changeComponent(componentName) {
            this.currentComponent = componentName;
        },
        windowHashTabs(){
            this.currentComponent = window.location.hash
        },
    },
    watch: {
        currentComponent(){
            if(location.hash === '#settings') return this.currentComponent = 'profile';
            this.changeComponent(this.currentComponent.replace('#', '').trim())
        },
    }

}
</script>

<style scoped>

</style>
